function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .icon_menu_relatorios_a,.icon_menu_relatorios_e{fill:#fff;}\n      .icon_menu_relatorios_a{stroke:#707070;}\n      .icon_menu_relatorios_b{clip-path:url(#icon_menu_relatorios_a);}\n      .icon_menu_relatorios_c{fill:#2196f3;}\n      .icon_menu_relatorios_d{fill:#1d83d4;}\n      .icon_menu_relatorios_f{fill:#607d8b;}\n      .icon_menu_relatorios_g{fill:#546d79;}\n      .icon_menu_relatorios_h{fill:#dedede;}\n      .icon_menu_relatorios_i{fill:#4caf50;}\n      .icon_menu_relatorios_j{fill:#429846;}\n    "), React.createElement("clipPath", {
  id: "icon_menu_relatorios_a"
}, React.createElement("rect", {
  className: "icon_menu_relatorios_a",
  width: 19,
  height: 19,
  transform: "translate(1800 1165)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon_menu_relatorios_b",
  transform: "translate(-1800 -1165)"
}, React.createElement("g", {
  transform: "translate(1800.494 1165)"
}, React.createElement("path", {
  className: "icon_menu_relatorios_c",
  d: "M12.476,1.617l-1.911.512a1.392,1.392,0,0,0-.979,1.7l3.79,14.147a1.392,1.392,0,0,0,1.7.979l1.912-.512a1.392,1.392,0,0,0,.979-1.7L14.173,2.6a1.393,1.393,0,0,0-1.7-.979Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_d",
  d: "M11.5,1.88l-.932.249a1.392,1.392,0,0,0-.979,1.7l3.79,14.147A1.392,1.392,0,0,0,14.718,19a1.369,1.369,0,0,0,.355-.047l1.027-.275-1.465-5.346-.04.012a.8.8,0,0,1-.206.027.793.793,0,0,1-.765-.587L11.371,4.372a.791.791,0,0,1,.545-.965Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_e",
  d: "M15.209,15.638a.8.8,0,0,1-.56.97l-1.529.41-.41-1.529,1.529-.41a.794.794,0,0,1,.97.56Z"
}), React.createElement("path", {
  d: "M15.209,15.638a.8.8,0,0,1-.56.97l-1.529.41-.41-1.529,1.529-.41a.794.794,0,0,1,.97.56Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_f",
  d: "M3.365,4.75H1.385A1.392,1.392,0,0,0,0,6.135V17.614A1.392,1.392,0,0,0,1.385,19H3.365A1.392,1.392,0,0,0,4.75,17.614V6.135A1.392,1.392,0,0,0,3.365,4.75Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_e",
  d: "M2.375,15.833a.794.794,0,0,1-.792.792H0V15.041H1.583A.794.794,0,0,1,2.375,15.833Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_e",
  d: "M2.375,13.458a.792.792,0,0,1-.792-.792V7.917a.792.792,0,0,1,1.583,0v4.75A.792.792,0,0,1,2.375,13.458Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_g",
  d: "M0,16.625V15.041H1.583a.792.792,0,0,1,0,1.583ZM2.375,4.75h-.99A1.392,1.392,0,0,0,0,6.135V17.614A1.392,1.392,0,0,0,1.385,19h.99V13.458a.792.792,0,0,1-.792-.792V7.917a.792.792,0,0,1,.792-.792Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_h",
  d: "M1.583,15.041H0v1.583H1.583a.792.792,0,0,0,0-1.583Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_h",
  d: "M2.375,7.125a.792.792,0,0,0-.792.792v4.75a.792.792,0,0,0,.792.792Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_i",
  d: "M8.114,0H6.135A1.392,1.392,0,0,0,4.75,1.385V17.614A1.392,1.392,0,0,0,6.135,19H8.114A1.392,1.392,0,0,0,9.5,17.614V1.385A1.392,1.392,0,0,0,8.114,0Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_e",
  d: "M7.125,15.833a.794.794,0,0,1-.792.792H4.75V15.041H6.333A.794.794,0,0,1,7.125,15.833Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_e",
  d: "M7.125,13.458a.792.792,0,0,1-.792-.792V2.375a.792.792,0,1,1,1.583,0V12.667A.792.792,0,0,1,7.125,13.458Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_j",
  d: "M4.75,16.625V15.041H6.333a.792.792,0,1,1,0,1.583ZM7.125,0h-.99A1.392,1.392,0,0,0,4.75,1.385V17.614A1.392,1.392,0,0,0,6.135,19h.99V13.458a.792.792,0,0,1-.792-.792V2.375a.792.792,0,0,1,.792-.792Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_h",
  d: "M6.333,15.041H4.75v1.583H6.333a.792.792,0,1,0,0-1.583Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_h",
  d: "M7.125,1.583a.792.792,0,0,0-.792.792V12.667a.792.792,0,0,0,.792.792Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_e",
  d: "M14.594,13.344a.792.792,0,0,1-.97-.56L11.371,4.372A.792.792,0,0,1,12.9,3.963l2.254,8.411a.793.793,0,0,1-.56.97Z"
}), React.createElement("path", {
  className: "icon_menu_relatorios_h",
  d: "M11.915,3.407a.791.791,0,0,0-.545.965l2.254,8.411a.792.792,0,0,0,.765.587.8.8,0,0,0,.206-.027l.04-.012Z"
})));

var SvgRelatorios = function SvgRelatorios(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRelatorios, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/relatorios.c6dfde18.svg";
export { ForwardRef as ReactComponent };